require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-why-did-i-pick-windows-phone.json") })
        }
      }, "path---post-why-did-i-pick-windows-phone");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-why-did-i-pick-windows-phone!./.cache/json/post-why-did-i-pick-windows-phone.json
// module id = 369
// module chunks = 231608221292675